import api from './api';

const employerConsultantApi = {
  getConsultantRequests: (params) => api.get('/employer/consultants/requests', { params }),
  
  respondToRequest: (requestId, action, reason) => 
    api.post(`/employer/consultants/requests/${requestId}/respond`, { action, reason }),
  
  getAssociatedConsultants: (params) => api.get('/employer/consultants', { params }),
  
  removeConsultant: (associationId) => api.delete(`/employer/consultants/${associationId}`),
  
  getPendingConsultantJobs: (params) => api.get('/employer/consultants/jobs/pending', { params }),
  
  approveConsultantJob: (jobId) => api.post(`/employer/consultants/jobs/${jobId}/approve`),
  
  rejectConsultantJob: (jobId, reason) => 
    api.post(`/employer/consultants/jobs/${jobId}/reject`, { reason })
};

export default employerConsultantApi;
